module.exports = __webpack_public_path__ + "static/media/nuparla em1 .1.8abf6674.png";